<!-- 气象预警详情 -->
<template>
  <transition name="dialog-fade">
    <div class="dialog-wrapper" v-if="visible" @click.self="close">
      <transition name="dialog-scale">
        <dl class="dialog" v-if="visible" v-loading="loading" v-show="!hidden">
          <dt class="dialog-title">
            <div class="intro">
              <div class="icon">
                <img :src="icon" alt="气象图标" />
              </div>
              <div class="info">
                <div class="title">{{ record.headLine ?? '--' }}</div>
                <div class="attr">
                  <div class="date" data-label="发布日期">{{ record.warnTime ?? '--' }}</div>
                  <div class="author" data-label="发布单位">{{ record.publish ?? '--' }}</div>
                </div>
              </div>
            </div>
            <span class="close" @click="close">关闭</span>
          </dt>
          <dd class="dialog-body">
            <div class="question">{{ record.content ?? '--' }}</div>
            <div class="answer">
              <div class="title"><strong>AI回复</strong></div>
              <div class="body">
                <div v-html="record.answer" class="ai-answer"></div>
              </div>
            </div>
          </dd>
          <dd class="dialog-footer">
            <button @click="close" class="cancel">取消</button>
            <button @click="showDetailedReplyDialog(record)" class="submit">查看完整分析过程</button>
          </dd>
        </dl>
      </transition>
      <DetailedReplyDialog ref="DetailedReplyDialogRef" @close="close" />
    </div>
  </transition>
</template>

<script>
import { GetWarningIcon, REASON } from '../constants';
import { getWarningDetail as GetWarningDetailApi } from '../api';
import DetailedReplyDialog from './dialog.vue';

export default {
  name: 'WeatherDialog',
  components: {
    DetailedReplyDialog,
  },
  data() {
    return {
      record: {},
      visible: false,
      hidden: false, // 弹出下级对话框时隐藏当前对话框
      loading: false,
    };
  },
  computed: {
    icon() {
      let self = this;
      const categoryCode = self.record?.category || '';
      const levelCode = self.record?.level || '';
      const src = GetWarningIcon('weather', levelCode, categoryCode);
      return src;
    },
  },
  methods: {
    showDetailedReplyDialog(content) {
      let self = this;
      self.hidden = true;
      self.$refs.DetailedReplyDialogRef.show(content);
    },
    close() {
      let self = this;
      self.visible = false;
      self.hidden = false;
      self.$emit('close');
    },
    show(record) {
      let self = this;
      self.visible = true;
      self.loading = true;
      typeof self.detail_cancel === 'function' && self.detail_cancel(); // 取消上一个请求以用参数重新获取
      const promise = GetWarningDetailApi(record);
      self.detail_cancel = promise.cancel || (() => {});
      promise
        .then((res) => {
          console.log('预警详情.res', record && record.type, res);
          self.record = res || {};
        })
        .catch((res) => {
          console.log('预警详情.err', record && record.type, res);
        })
        .finally(() => {
          self.loading = false;
        });
    },
  },
};
</script>

<style src="./style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}
@mixin linearText($from: #ffffff, $to: #5fde8c, $fromOffset: 0%, $toOffset: 100%) {
  color: $from;
  background: linear-gradient(to bottom, $from $fromOffset, $to $toOffset);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
%scrollbar {
  overflow: auto;

  &::-webkit-scrollbar {
    width: vh(6);
    height: vh(6);
  }

  &::-webkit-scrollbar-track {
    // background: rgba(10, 77, 19, 0.2);
    background: transparent;
    border-radius: vh(2);
  }

  &::-webkit-scrollbar-thumb {
    background: #00af6f;
    border-radius: vh(20);
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(48, 234, 168, 0.8);
  }

  &::-webkit-scrollbar-corner {
    background: rgba(48, 234, 168, 0.6);
  }
}
.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .intro {
    display: flex;
    .icon {
      width: vw(88);
      height: vh(67);
      margin-right: vw(16);
      font-size: 0;
      img {
        // width: 100%;
        height: 100%;
        display: block;
        margin: 0 auto;
        // background-color: #fff;
      }
    }
    .info {
      flex: 1;
      .title {
        font-size: fontSize(24);
        line-height: 1;
        font-weight: bold;
      }
      .attr {
        line-height: vh(43);
        div {
          display: inline-block;
          &::before {
            content: attr(data-label) '：';
            font-size: fontSize(16);
          }
          + div {
            margin-left: 4em;
          }
        }
      }
    }
  }
}
.dialog-body {
  padding: vh(10) 0;
  min-height: 100px;
  .question {
    font-weight: 400;
    font-size: fontSize(16);
    color: #b0ffd3;
    line-height: vh(32);
    margin: 0;
    text-indent: 2em;
  }
  .answer {
    margin: vh(15) 0 0;
    .title {
      background: linear-gradient(90deg, rgba(2, 79, 48, 0.8) 0%, rgba(2, 79, 48, 0.3) 100%);
      height: vh(21);
      line-height: vh(21);
      strong {
        font-size: fontSize(18);
        font-weight: bold;
        font-style: italic;
        padding: 0 0.5em;
        @include linearText(#fff, #5fde8c, 0%, 100%);
      }
    }
    .body {
      background: #00250d;
      padding: vh(17) vw(17);
      font-size: fontSize(16);
      line-height: 1.8;
      // min-height: vh(300);
      // max-height: vh(555);
      height: vh(460);
      overflow: auto;
      @extend %scrollbar;
    }
  }
}
</style>
